module.exports = __webpack_public_path__ + "static/media/pec-aruba.f05565c4.png";